import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'

import { getUrlByDomain } from '@js/common/getUrlByDomain'

import { InternalLinkWithWT } from '@f-fertighaus/applications/Next/components/common/InternalLink'
import { DEFAULT_LOCALE } from '@f-fertighaus/applications/Next/config/constants'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

export const FooterSection = () => {
  const { state, vendor, domain } = useHouseDetail()
  const INTENTIONAL_SPACE = ' '
  const getUrl = getUrlByDomain(domain)

  return (
    <FooterSectionContainer>
      <VendorInformationContainer>
        <Typography component='span' variant='body2'>
          <Typography
            component='span'
            variant='body2'
            fontWeight='fontWeightBold'>
            {`${state.name}${INTENTIONAL_SPACE}`}
          </Typography>
          {`von${INTENTIONAL_SPACE}`}
          <InternalLinkWithWT
            target={'_blank'}
            style={{ display: 'inline' }}
            arrowDirection={InternalLinkWithWT.arrowDirection.none}
            href={`${getUrl('vendorDetail')(vendor.slug)}`}
            wtPayload={{
              category: 'CTA-link',
              action: 'click',
              label: 'view-vendor-profile',
              location: 'vendor-section',
              values: [
                {
                  type: 'url',
                  value: `${getUrl('vendorDetail')(vendor.slug)}`
                },
                { type: 'text', value: state.vendor_verbose.display_name }
              ]
            }}>
            {state.vendor_verbose.display_name}
          </InternalLinkWithWT>
          <br />
          {`${t(
            'houseDetailPage.sections.details.overview.values.living_area_total',
            {
              area: Math.round(state.living_area_total).toLocaleString(
                DEFAULT_LOCALE
              )
            }
          )}${
            state.number_rooms
              ? ` | ${state.number_rooms} ${t(
                  'houseDetailPage.sections.details.overview.labels.number_rooms'
                )}`
              : ''
          }`}
        </Typography>
      </VendorInformationContainer>
    </FooterSectionContainer>
  )
}

const FooterSectionContainer = styled(Box)`
  display: flex;
  label: SidebarFooterContainer;
`

const VendorInformationContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 2;
`
